import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { MobileBottomNav } from './MobileBottomNav';
import { useSystemSettings } from '@/hooks/useSystemSettings';
import { AlertTriangle } from 'lucide-react';

export function Layout({ children }: { children: ReactNode }) {
  const { settings } = useSystemSettings();
  const maintenance = settings?.maintenance_mode;
  const isMaintenance = !!maintenance?.enabled;
  const { pathname } = useLocation();

  // Hide mobile bottom nav inside dashboard / auth flows
  const hideBottomNav =
    pathname.startsWith('/dashboard') ||
    pathname.startsWith('/login') ||
    pathname.startsWith('/register') ||
    pathname.startsWith('/forgot-password') ||
    pathname.startsWith('/reset-password');

  return (
    <div className="flex min-h-screen flex-col overscroll-y-none">
      {isMaintenance && (
        <div className="bg-destructive text-destructive-foreground py-2 px-4 text-center text-sm flex items-center justify-center gap-2">
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span>{maintenance?.message || 'Site is under scheduled maintenance. Some features may be unavailable.'}</span>
        </div>
      )}
      <Header />
      <main className="flex-1 overflow-x-hidden">
        {children}
      </main>
      <Footer />
      {!hideBottomNav && <MobileBottomNav />}
    </div>
  );
}
